module.exports = __webpack_public_path__ + "img/fracton.3ff76a6d.png";